import { FishbowlOutlineIcon } from './FishbowlOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 860D1C47-AD7E-4424-9CB7-BA9D2F86C129
 * name fishbowl-outline
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fishbowl-outline.svg
 * tags
 * - Animal 
 */
export const AquariumOutlineIcon = FishbowlOutlineIcon;
export default AquariumOutlineIcon